import { Button } from 'antd'
import React, { useEffect, useState } from 'react'
import ScheduleEmail from './Communication/ScheduleEmail'
import Faq from './Communication/Faq'
import Agreements from './Communication/Agreements'
import ItemsToBring from './Communication/ItemsToBring'
import MandatoryInfo from './Communication/MandatoryInfo'
import RequiredDocuments from './Communication/RequiredDocuments'
import MentorRequest from './Communication/MentorRequest'
import Security from './Communication/Security'
import RequiredDetails from './Communication/RequiredDetails'
import { leagueEventStore } from 'state/league/leagueEvent'
import { useLeagueStep11Communication } from 'api/league/LeagueCreation/leagueCreation'
import ButtonSpinner from 'components/global/ButtonSpinner'
import ConfirmationModal from './Modals/ConfirmationModal'
import {
  KidsRequiredDetails,
  ParentRequiredDetailsType,
  RequiredDeatilsTypes,
} from 'types/event/eventStep5'
import RulesAndRegulations from './Communication/RulesAndRegulations'

interface Step5Props {
  handleNext: () => void
  handleBack: () => void
}

const Step6: React.FC<Step5Props> = ({ handleNext, handleBack }) => {
  const [confirmModal, setConfirmModal] = useState<boolean>(false)
  const { mutate: createLeagueCommunication, isLoading } =
    useLeagueStep11Communication()

  const {
    leagueData,
    setLeagueData,
    agreements,
    setAgreements,
    itemsToBring,
    setItemsToBring,
    selectedFaqIds,
    setSelectedFaqIds,
    selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds,
    rulesAndRegulation,
    setRulesAndRegulation,
    riskLevel,
    requiredDetails,
  } = leagueEventStore(store => ({
    leagueData: store.leagueData,
    setLeagueData: store.setLeagueData,
    agreements: store.agreements,
    setAgreements: store.setAgreements,
    itemsToBring: store.itemsToBring,
    setItemsToBring: store.setItemsToBring,
    selectedFaqIds: store.selectedQuestions,
    setSelectedFaqIds: store.setSelectedQuestions,
    selectedRequiredDocumentIds: store.selectedRequiredDocumentIds,
    setSelectedRequiredDocumentIds: store.setSelectedRequiredDocumentIds,
    rulesAndRegulation: store.rulesAndRegulation,
    setRulesAndRegulation: store.setRulesAndRegulation,
    riskLevel: store.riskLevel,
    requiredDetails: store.requiredDetails,
  }))

  const mapToKeyValueObject = (arr: RequiredDeatilsTypes[]) => {
    return arr?.reduce(
      (acc, item) => {
        acc[item.key] = item.value
        return acc
      },
      {} as ParentRequiredDetailsType | KidsRequiredDetails,
    )
  }

  useEffect(() => {
    // leagueData.itemsToBring is populated with full item objects; the store (and the
    // itemsToBringIds payload) must hold string ids only — otherwise the API rejects with
    // "body/itemsToBringIds/N must be string" and the picker (which matches on item._id)
    // shows previously-saved items as unchecked.
    setItemsToBring(
      (leagueData.itemsToBring || []).map((item: any) =>
        typeof item === 'string' ? item : item?._id,
      ),
    )
    setSelectedFaqIds(leagueData.faqIds || [])
    setSelectedRequiredDocumentIds(leagueData.requiredDocumentIds || [])
    setAgreements(leagueData.agreementIds || [])
    setRulesAndRegulation(leagueData.regulationIds || [])
  }, [])

  const hanldeSubmit = () => {
    const payload: any = {
      requiredDocumentIds: selectedRequiredDocumentIds,
      itemsToBringIds: (itemsToBring || []).map((item: any) =>
        typeof item === 'string' ? item : item?._id,
      ),
      faqIds: selectedFaqIds,
      agreementIds: agreements,
      parentRequiredDetails: mapToKeyValueObject(
        requiredDetails.guardians,
      ) as ParentRequiredDetailsType,
      authorizedAdultRequiredDetails: mapToKeyValueObject(
        requiredDetails.adults,
      ) as ParentRequiredDetailsType,
      kidRequiredDetails: mapToKeyValueObject(
        requiredDetails.kids,
      ) as KidsRequiredDetails,
      regulationIds: rulesAndRegulation,
      riskLevel: riskLevel,
    }

    createLeagueCommunication(
      { leagueId: leagueData._id, payload },
      {
        onSuccess: data => {
          setLeagueData({ ...leagueData, ...data })
          handleNext()
        },
      },
    )
  }

  return (
    <>
      <div>
        <div
          className="scroller scroller-lg overflow-auto-y"
          style={{ height: `calc(100vh - 360px)` }}
        >
          <div className="mt-20px">
            <Faq />
          </div>
          <div className="mt-20px">
            <ItemsToBring />
          </div>
          <div className="mt-20px">
            <RulesAndRegulations />
          </div>
          <div className="mt-20px">
            <Agreements />
          </div>
          <div className="mt-20px">
            <MandatoryInfo />
          </div>
          <div className="mt-20px">
            <RequiredDocuments />
          </div>
          <div className="mt-20px">
            <ScheduleEmail />
          </div>
          {/* <div className="mt-20px">
            <MentorRequest />
          </div>
          <div className="mt-20px">
            <Security />
          </div> */}
        </div>
        <div className="flex align-center justify-between mb-26 mt-40px">
          <Button
            className="cancel-button flex align-center justify-center gap-10px"
            onClick={handleBack}
          >
            Back
          </Button>
          <Button className="stepper-button" onClick={hanldeSubmit}>
            {isLoading ? <ButtonSpinner size={20} color="#000" /> : 'Next'}
          </Button>
        </div>
      </div>

      {confirmModal && (
        <ConfirmationModal
          openModal={confirmModal}
          setopenModal={setConfirmModal}
        />
      )}
    </>
  )
}

export default Step6
